import { ISelectOption }    from '@typings/components';
import { EUserStatus }      from '@enums/common';
import { USER_STATUS_NAME } from '@utils/suggestions';

export const BIDDER_STATUS_COLOR: Record<EUserStatus, string> = {
  [EUserStatus.Unconfirmed] : '#525252',
  [EUserStatus.Inactive]    : '#0063A5',
  [EUserStatus.Active]      : '#019618',
  [EUserStatus.Banned]      : '#C1272D',
};

export const bidderStatusOptions: ISelectOption[] = [{
  label : USER_STATUS_NAME[EUserStatus.Banned],
  value : EUserStatus.Banned,
}, {
  label : USER_STATUS_NAME[EUserStatus.Inactive],
  value : EUserStatus.Inactive,
}, {
  label    : USER_STATUS_NAME[EUserStatus.Unconfirmed],
  value    : EUserStatus.Unconfirmed,
  disabled : true,
}, {
  label : USER_STATUS_NAME[EUserStatus.Active],
  value : EUserStatus.Active,
}];
